module.exports = __webpack_public_path__ + "media/images/client_logos/logo_comme_jaime_200-c012bcabfae126fb4e8bb01071472410.png";